import styled from "styled-components";

export const SliderContainer = styled.div`
  width: 100%;
  padding: ${(props) => props.padding || "0px 0 10px"};
`;

export const SlideBox = styled.div`
  background-color: ${(props) => props.backgroundColor || "white"};
  border-radius: ${(props) => props.borderRadius || "16px"};
  box-shadow: ${(props) => props.boxShadow || "0 2px 8px rgba(0, 0, 0, 0.05)"};
  padding: ${(props) => props.padding || "20px"};
  margin: 0 auto;
  max-width: ${(props) => props.maxWidth || "500px"};
  border: ${(props) => props.border || "2px solid #e2e4e9"};

  .details-center {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .details-center:first-child {
    margin-top: ${(props) => props.firstItemMarginTop || "-15px"};
  }

  .details-center:not(:first-child) {
    margin-top: ${(props) => props.otherItemsMarginTop || "10px"};
  }
`;

export const BoxTitle = styled.h3`
  color: ${(props) => props.color || "#142c1f"};
  margin: ${(props) => props.margin || "0 0 16px"};
  font-size: ${(props) => props.fontSize || "16px"};
  text-align: ${(props) => props.textAlign || "center"};
`;

export const ContentContainer = styled.div`
  height: ${(props) => props.height || "250px"};
  position: relative;
`;

export const Details = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.gap || "10px"};
  margin-top: ${(props) => props.marginTop || "15px"};

  div {
    display: flex;
    align-items: center;
    gap: ${(props) => props.itemGap || "10px"};
  }

  .bullet {
    width: ${(props) => props.bulletSize || "15px"};
    height: ${(props) => props.bulletSize || "15px"};
    border-radius: 50%;
  }

  h3 {
    font-size: ${(props) => props.labelSize || "16px"};
    color: ${(props) => props.labelColor || "#142c1f"};
    display: flex;
    gap: ${(props) => props.labelGap || "8px"};
    margin: 0;
    min-width: ${(props) => props.labelMinWidth || "170px"};

    span {
      font-size: inherit;
      font-weight: inherit;
      text-align: center;
    }
  }
`;

export const CustomNavigation = styled.div`
  position: relative;
  height: 0;
  margin-top: ${(props) => props.marginTop || "40px"};
  padding-bottom: ${(props) => props.paddingBottom || "40px"};

  .swiper-button-prev.custom,
  .swiper-button-next.custom {
    position: absolute;
    bottom: ${(props) => props.navigationBottom || "-30px"};
    width: ${(props) => props.navigationSize || "25px"};
    height: ${(props) => props.navigationSize || "25px"};
    background: none;

    &::after {
      display: none;
    }
  }

  .swiper-button-prev.custom {
    left: ${(props) => props.prevButtonLeft || "calc(50% - 35px)"};
  }

  .swiper-button-next.custom {
    left: ${(props) => props.nextButtonLeft || "calc(50%)"};
  }
`;
